import { alpha, Box, Stack, Typography } from '@mui/material';
import { SecurityOutlined } from '@mui/icons-material';
import Grid2 from '@mui/material/Unstable_Grid2';
import React, { useEffect } from 'react';
import { LoadingMask } from 'src/Common/Components/LoadingMask';
import { UserRoleCard } from '../../UserManagement/Components/UserRoleCard';
import { SettingsSection } from '../Components/SettingsSection';
import useEkko from 'src/Common/Providers/EkkoProvider';

export const RolesSection = (): React.JSX.Element => {
  const { currentUser: user, isRefreshingUser, refreshUser } = useEkko();
  const roleMappings = user?.roleMappings ?? [];

  useEffect(() => {
    if (user === undefined && !isRefreshingUser) {
      refreshUser();
    }
  }, [user, isRefreshingUser]);

  return (
    <SettingsSection title={'Roles & Permissions'} description={'Roles assigned to your account.'}>
      {isRefreshingUser || !user ? (
        <LoadingMask width={60} height={60} />
      ) : roleMappings.length === 0 ? (
        <Stack direction={'column'} spacing={1.5} alignItems={'center'} sx={{ py: 5, textAlign: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 56,
              height: 56,
              borderRadius: '50%',
              color: 'primary.main',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
              '& .MuiSvgIcon-root': { fontSize: 28 },
            }}
          >
            <SecurityOutlined />
          </Box>
          <Typography variant={'h6'} fontWeight={700}>
            No roles assigned
          </Typography>
          <Typography variant={'body2'} color={'text.secondary'} sx={{ maxWidth: 380 }}>
            {"Your account doesn't have any roles yet. Contact an administrator if you need access."}
          </Typography>
        </Stack>
      ) : (
        <Grid2 container spacing={2}>
          {roleMappings.map((mapping, index) => (
            <Grid2 key={index} xs={12} sm={6} md={4} lg={3}>
              <UserRoleCard nodeRoleMapping={mapping} />
            </Grid2>
          ))}
        </Grid2>
      )}
    </SettingsSection>
  );
};
